// 数量选择器——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `module/inputNumber/index${i + 1}`,
  name: `module/inputNumberIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/inputNumber/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 数量选择器——主流程，开始
    ...MainRoutes
  ]
}
